export default {
  title: 'Catalog Games',
  subtitle: 'Browse verified digital game keys. Instant delivery. Unbeatable prices.',
  priceAny: 'Any price',
  priceUnder10: 'Under €10',
  price10to30: '€10 – €30',
  price30to60: '€30 – €60',
  price60plus: '€60+',
  pricePlaceholder: 'Price',
  sortRelevance: 'Relevance',
  sortNewest: 'Newest',
  sortPriceAsc: 'Price: low to high',
  sortPriceDesc: 'Price: high to low',
  sortNameAsc: 'Name: A–Z',
  platformPlaceholder: 'Platform',
  genrePlaceholder: 'Genre',
  sortBy: 'Sort by:',
  activeFilters: 'Active filters:',
  clearAll: 'Clear All',
  results: '{count} games',
  throttledTitle: 'Connection throttled',
  throttledBody: 'Too many requests — please wait a moment and try again. Our servers are currently experiencing high traffic.',
  unavailableTitle: 'Catalog unavailable',
  unavailableBody: "Couldn't reach the catalog API. Start the backend stack, then try again.",
  noResultsTitle: 'No listings found',
  noResultsBody: "We couldn't find any products matching your current filters. Try adjusting your search parameters.",
  clearFilters: 'Clear filters',
  outOfStock: 'Out of stock',
  view: 'View',
  unavailable: 'Unavailable',
  addToWishlist: 'Add to wishlist',
  // Terminal catalog page
  titlesDetected: 'Titles detected',
  searchDb: 'Search database',
  sortPopularity: 'Popularity',
  addToCart: 'Add to cart',
  baseGame: 'Base game',
  dlc: 'DLC',
  prev: 'Prev',
  next: 'Next',
};
